/**
 * @generated SignedSource<<6d4c999ab13c323b500107f9a0f2bc74>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type actionSection_servicedeskSettingsVirtualAgentLanding_projectRef$data = {
  readonly " $fragmentSpreads": FragmentRefs<"createVirtualAgentSection_servicedeskSettingsVirtualAgentLanding">;
  readonly " $fragmentType": "actionSection_servicedeskSettingsVirtualAgentLanding_projectRef";
};
export type actionSection_servicedeskSettingsVirtualAgentLanding_projectRef$key = {
  readonly " $data"?: actionSection_servicedeskSettingsVirtualAgentLanding_projectRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"actionSection_servicedeskSettingsVirtualAgentLanding_projectRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "actionSection_servicedeskSettingsVirtualAgentLanding_projectRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "createVirtualAgentSection_servicedeskSettingsVirtualAgentLanding"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "d5b646cdb69fbbdfd17c0f3546dc1c2a";

export default node;
